<template>
  <div class="card shadow-sm border p-8 bg-white my-5">
    <!-- Bloco de login e senha -->
    <div class="flex lg:flex-row flex-col">
      <div class="w-full p-2">
        <Input type="default" v-model="catraca.login" label="Login" placeholder="Login da Integração Catraca" />
      </div>
      <div class="w-full p-2">
        <Input type="default" v-model="catraca.senha" label="Senha da Integração Catraca"
          placeholder="Senha da Integração Catraca" />
      </div>
    </div>

    <!-- Bloco de URLs -->
    <div class="flex lg:flex-row flex-col">
      <div class="w-full p-2">
        <Input type="default" v-model="catraca.url_catraca" label="URL da catraca"
          placeholder="URL da Integração Catraca" />
      </div>
      <div class="w-full p-2">
        <Input type="default" v-model="catraca.url_login" label="URL para Logar na Integração"
          placeholder="URL para Logar na Integração (/api/v1/Logon)" />
      </div>
    </div>

    <!-- Bloco de NAK -->
    <div class="flex lg:flex-row flex-col">
      <div class="w-full p-2">
        <Input type="textarea" v-model="catraca.nak" label="NAK" placeholder="NAK" />
      </div>
    </div>

    <!-- Bloco de mapeamento de produtos -->
    <div class="flex lg:flex-row flex-col mt-4">
      <ProductMapping :products="produtos" v-model="catraca.tradutor" />
    </div>

    <!-- Botões de ações -->
    <div class="flex flex-wrap justify-end gap-3 mt-6">
      <Button @click="salvarIntegracao" color="primary" text="Salvar Integração" />
      <Button @click="testarIntegracao" color="secondary" text="Testar Integração" />
      <Button @click="cadastrarAparelhos" color="terciary" text="Cadastrar Aparelhos" />
    </div>

    <!-- Mensagem de status -->
    <p v-if="statusIntegracao" class="text-sm mt-4"
      :class="{ 'text-green-600': statusIntegracao.sucesso, 'text-red-600': !statusIntegracao.sucesso }">
      {{ statusIntegracao.mensagem }}
    </p>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, defineProps, inject } from 'vue';
import { GET, POST, PUT } from '../../../services/api';
import Input from '../Input.vue'; // Ajuste o caminho se necessário
import Button from '../Button.vue'; // Ajuste o caminho se necessário
import axios from 'axios';
import ProductMapping from './MapeamentoProdutos.vue'


const props = defineProps({
  eventId: {
    type: String,
    required: true,
  },
});

const catraca = reactive({
  id: '',
  login: '',
  senha: '',
  "url_catraca": '',
  "url_login": '',
  nak: '',
  tradutor: '',
});
const loader = inject("loading");
const alert = inject("alert");
const statusIntegracao = ref(null);
const loading = ref(false);
const isNew = ref(false);
const produtos = ref([]); // Lista de produtos, se necessário

async function carregarIntegracao() {
  loading.value = true;
  statusIntegracao.value = null;
  try {
    const res = await GET(`/catraca/${props.eventId}`);
    if (!res || !res.success) {
      isNew.value = true;
      catraca.id = '';
      catraca.login = '';
      catraca.senha = '';
      catraca["url_catraca"] = '';
      catraca["url_login"] = '';
      catraca.nak = '';
      catraca.tradutor = '';
    } else {
      const data = res.data
      console.log('Catraca carregada:', res);
      isNew.value = false;
      catraca.id = data.id || '';
      catraca.login = data.login || '';
      catraca.senha = data.senha || '';
      catraca["url_catraca"] = data["url_catraca"] || '';
      catraca["url_login"] = data["url_login"] || '';
      catraca.nak = data.nak || '';
      catraca.tradutor = data.tradutor
        ? data.tradutor
        : '';
    }
  } catch (err) {
    statusIntegracao.value = {
      sucesso: false,
      mensagem: 'Erro ao carregar integração: ' + (err.message || err),
    };
  } finally {
    loading.value = false;
  }
}

async function salvarIntegracao() {
  loader.open()
  statusIntegracao.value = null;

  let mapeamento = {};
  try {
    mapeamento = catraca.tradutor
      ? catraca.tradutor
      : {};
  } catch {
    alert.open('Atenção!', 'Mapeamento de produtos JSON inválido.', 'warning');
    statusIntegracao.value = {
      sucesso: false,
      mensagem: 'Mapeamento de produtos JSON inválido.',
    };
    loader.close()
    return;
  }

  const payload = {
    login: catraca.login,
    senha: catraca.senha,
    "url_catraca": catraca["url_catraca"],
    "url_login": catraca["url_login"],
    "id_evento": props.eventId,
    nak: catraca.nak,
    tradutor: mapeamento,
  };

  try {
    await POST(`/catraca`, payload);
    statusIntegracao.value = { sucesso: true, mensagem: 'Integração salva com sucesso!' };
    await carregarIntegracao();
    alert.open('Sucesso!', 'Integração atualizadda com sucesso.', 'success');
  } catch (err) {
    statusIntegracao.value = {
      sucesso: false,
      mensagem: 'Erro ao salvar integração: ' + (err.message || err),
    };
  } finally {
    loader.close()
  }
}



async function testarIntegracao() {
  loader.open()
  statusIntegracao.value = null;
  try {

    const res = await axios.get(
      `${catraca["url_catraca"]}${catraca["url_login"]}?username=${catraca.login}&password=${catraca.senha}`,
      {
        headers: {
          Authorization: `${catraca.nak}`
        }
      }
    );



    statusIntegracao.value = {
      sucesso: true,
      mensagem: res?.data?.message || 'Teste realizado com sucesso!',
    };
    alert.open('Sucesso!', statusIntegracao.value.mensagem, 'success');
  } catch (err) {
    statusIntegracao.value = {
      sucesso: false,
      mensagem: 'Erro ao testar integração: ' + (err.response?.data?.message || err.message || err.Message || err),
    };
    alert.open('Atenção!', statusIntegracao.value.mensagem, 'warning');
  } finally {
    loader.close()
  }
}

async function cadastrarAparelhos() {
  loader.open()
  statusIntegracao.value = null;
  try {
    const res = await POST(`/catraca/${props.eventId}/create/aparelhos`);
    statusIntegracao.value = {
      sucesso: true,
      mensagem: res?.message || 'Aparelhos cadastrados com sucesso!',
    };
    alert.open('Sucesso!', statusIntegracao.value.mensagem, 'success');
  } catch (err) {

    const errorMessage = err?.data?.message || err?.data || 'Erro desconhecido';
    statusIntegracao.value = {
      sucesso: false,
      mensagem: 'Erro ao cadastrar aparelhos: ' + (errorMessage || err),
    };
    alert.open('Atenção!', statusIntegracao.value.mensagem, 'warning');
  } finally {
    loading.value = false;
    loader.close()
  }
}
async function loadProdutos() {
  try {
    const res = await GET(`/produto/${props.eventId}/evento/catraca`);
    if (res) {
      produtos.value = res || [];
      return produtos.value;
    } else {
      alert.open('Atenção!', 'Nenhum produto encontrado para este evento.', 'warning');
      return [];
    }
  } catch (err) {
    alert.open('Atenção!', 'Nenhum produto encontrado para este evento.', 'warning');
    return [];
  }
}

onMounted(async () => {
  loader.open()
  await carregarIntegracao();
  await loadProdutos();
  loader.close()
});

</script>

<style scoped>
/* Ajuste os estilos se quiser */
</style>
